const view = path => () => import(`../views/pages/tftUniversityShowdown/${path}.vue`);

export default [
  {
    path: '/b/:id(tft_university_showdown)',
    name: 'tftUniversityShowdownHome',
    component: view('TftUniversityShowdownHome'),
    meta: { id: 0 },
  },
];
